export default __webpack_public_path__ + "static/media/reactImg.423c2e2a.svg";